module.exports = __webpack_public_path__ + "assets/img/t1.45c222a7.png";